// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__Wb4CX","logo":"Footer_logo__1dEML","social":"Footer_social__vUYCe","bottom":"Footer_bottom__syzdZ","link_head":"Footer_link_head__DiUoT"};